import { render, staticRenderFns } from "./PractitionerCreate.vue?vue&type=template&id=405e923d"
import script from "./PractitionerCreate.vue?vue&type=script&lang=js"
export * from "./PractitionerCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports